import React from 'react';

import {
  onLightShadowSm,
  onLightSurfaceActive,
  onLightSurfacePrimary,
  onLightTextPrimary,
  radiusMd,
} from '@thinkific/chalk/design-tokens/jsTokens';

import { useTheme } from 'components/new/providers/CommunityThemeProvider';

const VariableOverrides = () => {
  const { action, onAction, font } = useTheme();
  return (
    <style>
      {`
        .str-chat {
          --str-chat__primary-color: ${action.primary.source};
          --str-chat__edit-message-modal-send-button-background-color: ${action.primary.source};
          --str-chat__edit-message-modal-send-button-color: ${onAction.primary.source};
          --str-chat__primary-color-low-emphasis: ${onLightSurfaceActive};
          --str-chat__message-reaction-background-color: ${action.primary.light};
          --str-chat__font-family: ${font};
          --str-chat__message-input-tools-color: ${onLightTextPrimary};

          --str-chat__message-max-width: calc(var(--str-chat__spacing-px) * 960);

          --str-chat__message-options-button-size: calc(var(--str-chat__spacing-px) * 36);
          --str-chat__message-options-border-radius: 4px;

          --str-chat__message-reaction-background-color: ${onLightSurfacePrimary};
          --str-chat__own-message-reaction-background-color: ${action.primary.lightest};
          --str-chat__message-options-color: ${onLightTextPrimary};

          --str-chat__message-actions-box-box-shadow: ${onLightShadowSm};
          --str-chat__message-actions-box-border-radius: ${radiusMd};
          --str-chat__message-reactions-options-box-shadow: ${onLightShadowSm};
          --str-chat__message-reactions-options-border-radius: ${radiusMd};

          --str-chat__message-reactions-option-hover-background-color: ${onLightSurfaceActive};
          --str-chat__message-actions-box-item-hover-background-color: ${onLightSurfaceActive};
          --str-chat__message-reactions-option-border-radius: ${radiusMd};

          --str-chat__body2-text: 1rem / 1.5 var(--str-chat__font-family);

          --str-chat__modal-border-radius: ${radiusMd};
          --str-chat__attachment-preview-image-border-radius: ${radiusMd};
          --str-chat__attachment-preview-list-border-radius: ${radiusMd};
          --str-chat__image-attachment-border-radius: 0;
          --str-chat__attachment-margin: 0;
          --str-chat__image-attachment-background-color: transparent;
          --str-chat__attachment-preview-file-border-radius: ${radiusMd};
        }
      `}
    </style>
  );
};

export default VariableOverrides;
